// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"30147f75","612":"c8490c93","637":"987ea626","784":"675630a5"}[chunkId] + ".chunk.css";
};